import request, { BASE_URL } from './request'

export interface Leader {
  id: string
  telegram_id: string
  referral_code: string
  username: string
  points: number
  first_name: string
  last_name: string
  created_at: string
  updated_at: string
  photo_url: string
}

export interface LeadersResponse {
  items: Leader[]
  count: number
}

export const getLeaders = async (): Promise<LeadersResponse> =>
  request({
    method: 'GET',
    url: `${BASE_URL}/customers/leaders`,
  })
